import { useMutation, type UseMutationOptions } from "@tanstack/react-query";

import type {
  CreateCrmProductRequestDto,
  CreateCrmProductResponseDto
} from "../../dtos/crm-product-dto";
import { ProductService } from "../../services/product-service";

type UsePostCreateCrmProductMutationParams = {
  options?: UseMutationOptions<
    CreateCrmProductResponseDto,
    unknown,
    CreateCrmProductRequestDto
  >;
};

export const usePostCreateCrmProductMutation = ({
  options
}: UsePostCreateCrmProductMutationParams = {}) => {
  return useMutation({
    mutationFn: async (payload) => {
      return await ProductService.createCrmProduct({ payload });
    },
    ...options
  });
};
